<template>
    <div
        :class="{'user_view__tabs__item--active':active}"
        :style="{borderColor:borderColor}"
        class="user_view__tabs__item">
        <p  class="user_view__tabs__item__title">
            {{title}}
        </p>
        <img  
            class="user_view__tabs__item__image" 
            :src="image" />
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        image: String,
        active: Boolean,
        borderColor: String
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/Tap.vue